module.exports = __webpack_public_path__ + "img/20200515_155952.5872a358.jpg";